// extracted by mini-css-extract-plugin
export var container = "_mq-0";